export const SPOT_ILLUSTRATION_VERSION_FOLDER = 'v2';
//# sourceMappingURL=versions.js.map